/**
 * Constants for the Home feature
 *
 * User-visible copy lives in the `home` i18n namespace (./i18n), never here:
 * a module-level string is frozen in whatever language was active at load time.
 */

export const CLASS_NAMES = {
  WRAPPER: 'home-wrapper',
  BODY: 'home-body',
  CONTENT_CARD: 'home-content-card',
  SCROLL_AREA: 'home-scroll-area',
} as const;

export const DEBOUNCE_MS = 300;

export const PAGINATION_THRESHOLD = 500;
